'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.span.withConfig({
  componentId: 's1543se1-0'
})(['font-size:10px;', ''], function (p) {
  return p.error && '\n    font-size: 16px;\n    color: #fff;\n  ';
});